import type { GetWebhookEventTypesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetWebhookEventTypesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

import type { WebhookEventTypeRow } from './types';

export const useListWebhookEventTypes = createQueryHook<
  undefined,
  WebhookEventTypeRow[],
  GetWebhookEventTypesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.webhook.listEventTypes.queryOptions(),
  mapTrpcDataToGraphQL: (
    data
  ): StrictMappedGraphQLSelection<GetWebhookEventTypesQuery> => ({
    organisation_webhook_event_type: (data ?? []).map((eventType) => ({
      __typename: 'organisation_webhook_event_type' as const,
      Id: eventType.Id,
      EventType: eventType.EventType,
      Description: eventType.Description ?? undefined,
      RequiredModule: eventType.RequiredModule ?? undefined,
    })),
  }),
  graphqlDocument: GetWebhookEventTypesDocument,
});
